var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLittleQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.125 5.79167H5.79167V0.125H0.125V5.79167ZM1.54167 1.54167H4.375V4.375H1.54167V1.54167ZM0.125 12.875H5.79167V7.20833H0.125V12.875ZM1.54167 8.625H4.375V11.4583H1.54167V8.625ZM7.20833 0.125V5.79167H12.875V0.125H7.20833ZM11.4583 4.375H8.625V1.54167H11.4583V4.375ZM7.21542 7.20833H8.63208V8.625H7.21542V7.20833ZM8.63208 8.625H10.0488V10.0417H8.63208V8.625ZM7.21542 10.0417H8.63208V11.4583H7.21542V10.0417ZM10.0488 10.0417H11.4654V11.4583H10.0488V10.0417ZM11.4654 11.4583H12.8821V12.875H11.4654V11.4583ZM8.63208 11.4583H10.0488V12.875H8.63208V11.4583ZM10.0488 7.20833H11.4654V8.625H10.0488V7.20833ZM11.4654 8.625H12.8821V10.0417H11.4654V8.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleQr);
export default __webpack_public_path__ + "static/media/littleQr.cb42e4b9e09c70aca7770c4541db0930.svg";
export { ForwardRef as ReactComponent };